module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAsAAAAoCAIAAACn9pfpAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAIhJREFUeNpifPbsGQNewMRACIyqGFWBDk6fOZOXnw9hM6KlsZcvX06fOXPB/PnMTEx3794FirDA5T5+/Lh+w4YpkydD9IiKikLEESomT5kybepUfO7Iy83t7OyUlpZGU4HujlevXk2fMQPoDiaYOxix5oazZ88uXLRo0sSJOFWMxv6oCggACDAAYPs5tQ9SvvwAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/shipIcons/buttons/SHRINK.png
// module id = E+hE
// module chunks = 18